<section
  class="lb-header"
  [ngClass]="{'header-fix' : category?.BackgroundImageUrl !== '' && !isDesktop && !mobileDetail,
    'rebranding': globalVars.FEATURES?.MSO_NewReBranding, 'header-before': !isIconCategory}"
>
  <h2 *ngIf="isIconCategory" class="lb-header--title color-light">
    <div class="lb-header--WithIcon">
      <img class="lb-header--imgIcon" [src]="category.CategoryGameGroupIcon" />
      <p class="lb-header--txt">{{ title | slotName}}</p>
      <span class="lb-header--counter" *ngIf="!!jp && isJackpotCounter">
        {{ jackpots$ | async | parseMoney: [4] }}
      </span>
    </div>
  </h2>
  <h2 *ngIf="!isIconCategory" class="lb-header--title color-light">
    {{ title | slotName}}
    <span class="lb-header--counter" *ngIf="!!jp && isJackpotCounter"> {{ jackpots$ | async | parseMoney: [4] }} </span>
  </h2>
  <div>
    <button
      *ngIf="category.CustomizedService === constants.googleData && !isDesktop"
      class="cd-button--sm background-color-transparent hide-details"
      (click)="category.hideDetails = !category.hideDetails"
    >
      <span *ngIf="category.hideDetails; else hideDetails">
        <ion-icon name="eye-outline" class="hide-details__icon"></ion-icon>
        <span class="cd-button--subtitle">{{ 'CasShowDetails' | translate }}</span>
      </span>
      <ng-template #hideDetails>
        <ion-icon name="eye-off-outline" class="hide-details__icon"></ion-icon>
        <span class="cd-button--subtitle">{{ 'CasHideDetails' | translate }}</span>
      </ng-template>
    </button>
    <button class="cd-button--sm background-color-transparent border-color-white" (click)="select($event)">
      <span class="cd-button--subtitle color-light">{{ cta | translate }}</span>
    </button>
  </div>
</section>
